const POPUP_SELECTOR = '#bogos-main-popup-more-product-container';
const BOPIS_GIFT_MARKERS = ['gwp bopis surprise sample bag', '127824'];

/**
 * Identifies the REN-257 gift selector without affecting other BOGOS offers.
 *
 * @param {{textContent?: string | null} | null | undefined} popup
 */
export function isBopisGiftPopup(popup) {
  const text = String(popup?.textContent || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  return BOPIS_GIFT_MARKERS.some((marker) => text.includes(marker));
}

function closeSuppressedPopup(popup) {
  if (popup.dataset.rennaiBopisCloseRequested === 'true') return;

  popup.dataset.rennaiBopisCloseRequested = 'true';
  const closeButton = popup.querySelector(
    'button[aria-label*="close" i], button[class*="close" i], [role="button"][aria-label*="close" i]'
  );
  closeButton?.click();
}

function inspectPopup() {
  const popup = document.querySelector(POPUP_SELECTOR);
  if (!popup) return;

  if (isBopisGiftPopup(popup)) {
    popup.dataset.rennaiBopisSuppressed = 'true';
    popup.removeAttribute('data-rennai-bogos-inspecting');
    queueMicrotask(() => closeSuppressedPopup(popup));
    return;
  }

  // Keep newly inserted BOGOS markup out of the first paint while its product
  // content is still being hydrated. Other offers are released on the next frame.
  popup.dataset.rennaiBogosInspecting = 'true';
  requestAnimationFrame(() => {
    if (!popup.isConnected || isBopisGiftPopup(popup)) {
      inspectPopup();
      return;
    }

    popup.removeAttribute('data-rennai-bogos-inspecting');
    popup.removeAttribute('data-rennai-bopis-suppressed');
    popup.removeAttribute('data-rennai-bopis-close-requested');
  });
}

if (typeof document !== 'undefined' && typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(inspectPopup);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  inspectPopup();
}
